import type {CustomFormField} from 'src/types/crm';

import * as React from 'react';
import useLabelTranslation from 'src/hooks/useLabelTranslation';

import {
  RadioGroup,
  RadioButton,
} from '@spaced-out/ui-design-system/lib/components/RadioButton';
import classify from 'src/utils/classify';
import css from './index.css';


type FormikFieldType = {
  value: string | boolean;
  name: string;
};

type BooleanRadioGroupProps = {
  field: CustomFormField;
  formikField: FormikFieldType;
  onChange: (field: string, value: string | boolean) => void;
  isRequired: boolean;
  error: string | null | undefined;
  touched: boolean;
  label: string;
  classNames?: string;
  disabled?: boolean;
};

export const BooleanRadioGroup = ({
  field,
  formikField,
  isRequired,
  onChange,
  label,
  error,
  touched,
  classNames,
  disabled = false,
}: BooleanRadioGroupProps) => {
  const {t, makeKey} = useLabelTranslation();
  const hasError = Boolean(error && touched);
  const stringValue =
    typeof formikField.value === 'boolean'
      ? formikField.value
        ? 'Yes'
        : 'No'
      : String(formikField.value || '');

  return (
    <div
      {...formikField}
      className={classify(css.booleanInputContainer, classNames)}
    >
      {label && (
        <label className={css.label}>
          {t(makeKey(label), label)}
          {isRequired && <span className={css.required}>*</span>}
        </label>
      )}

      <RadioGroup
        align="horizontal-fluid"
        name={`custom_${field.customFieldId}`}
        value={stringValue}
        onChange={(value) => onChange(formikField.name, value)}
        error={hasError}
        errorText={error || ''}
      >
        <RadioButton value="Yes" disabled={disabled}>
          {t('Yes', 'Yes')}
        </RadioButton>

        <RadioButton value="No" disabled={disabled}>
          {t('No', 'No')}
        </RadioButton>
      </RadioGroup>
    </div>
  );
};
